<template>
  <div class="PlaylistSearch">
    <DefaultInputField
        :isLoading="isLoading"
        :placeholder="placeholder"
        :value="value"
        :isInputEmpty="isInputEmpty"
        type="text"
        @blur="handleBlur"
        @click="handleClick"
        @input="inputChanged"
    />
    <div :class="{ disabled: !isLoading, visible: isLoading }"
         class="loader">
    </div>
    <font-awesome-icon :class="{'yellow-color' : isInputEmpty, 'white-color': !isInputEmpty,
     visible: !isLoading, disabled: isLoading }"
                       icon="search"/>
  </div>
</template>

<script>
import DefaultInputField from '@/components/input/DefaultInputField.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

library.add(faSearch)

const DEBOUNCE_TIMEOUT = 200

export default {
  name: 'PlaylistSearch',
  components: { DefaultInputField },
  props: {
    placeholder: {
      type: String,
      default: 'Wyszukaj playlistę',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isInputEmpty: {
      type: Boolean,
      default: false,
    },

  },
  data () {
    return {
      debounceTimeout: null,
      value: '',
      id: null,
    };
  },
  methods: {
    handleBlur(e) {
      this.$emit('blur', e)
    },

    handleClick(e) {
      this.$emit('click', e)
    },

    inputChanged (event, id) {
      this.value = event
      this.id = id
      this.$emit('input', event, id)

      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout)
      }

      this.debounceTimeout = setTimeout(
          () => this.$emit('search', event),
          DEBOUNCE_TIMEOUT
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";
@import "@/assets/scss/bulma/projectBulma.scss";

.PlaylistSearch {
  display: grid;
  position: relative;

  .disabled {
    display: none
  }

  .visible {
    display: block;
  }

  svg {
    font-size: 22px;
    position: absolute;
    right: 0;
    bottom: 28px;
    transition: 0.1s ease-out color;
  }

  .white-color {
    color: white;
  }

  .yellow-color {
    color: $primary;
  }

  &:focus-within {
    svg {
      color: $primary;
    }
  }

  .loader {
    width: 20px;
    margin: 1px;
    font-size: 10px;
    position: absolute;
    right: 0;
    bottom: 24px;
    text-indent: -9999em;
    border-top: 0.5em solid $primary;
    border-right: 0.5em solid $primary;
    border-bottom: 0.5em solid $primary;
    border-left: 0.5em solid #ffffff;
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 0.8s infinite linear;
  }

  .loader,
  .loader:after {
    border-radius: 100%;
    width: 2em;
    height: 2em;
  }

  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
}
</style>
